import React from 'react'
import './family-info-gutter.css'
import ContactInfoTab from './ContactInfoTab/ContactInfoTab'
import SchedulingTab from './SchedulingTab/SchedulingTab'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { getRequestHeaders } from '../../api'

let gutterTabs = [
    {label: 'Contact Info', type: 'contact-info'},
    {label: 'Scheduling', type: 'scheduling'}
]

const FamilyInfoGutter = ({
    modalInfo,
    setModalInfo,
    setCopyConfirmationPopup,
    setSchedulingHelperTeacherId,
    teacherDistanceSuggestions,
    setTeacherDistanceSuggestions,
    setFamilyProfile,
    onOpenDistanceScheduler,
    onOpenBookingDemo,
    onOpenTeacherMap
}) => {
    const [tabState, setTabState] = React.useState('contact-info')
    const [numberOfInvitations, setNumberOfInvitations] = React.useState(0)
    const [familyInfo, setFamilyInfo] = React.useState({})
    const [loadingFamilyInfo, setLoadingFamilyInfo] = React.useState(true)
    const [hookUpFamily, setHookUpFamily] = React.useState(true)
    const [scheduledEvents, setScheduledEvents] = React.useState([])

    React.useEffect(() => {
        axios.get(`${baseUrl}/teacher-invitations/${modalInfo.familyId}`)
        .then((res) => {
            let count = 0
            res.data.forEach((invitation) => invitation.interested && count++)
            setNumberOfInvitations(count)
        })
        .catch((err) => console.log(err))

        getFamilyInfo()

    }, [])

    const getFamilyInfo = async () => {
        setLoadingFamilyInfo(true)
        if(!modalInfo.familyId || modalInfo.familyId === 'none') {
            setHookUpFamily(true)
            setLoadingFamilyInfo(false)
        } else {
            await axios.get(`${baseUrl}/calendar/family/${modalInfo.familyId}`, getRequestHeaders())
            .then(res => {
                setScheduledEvents(res.data)
            })
            .catch(err => console.log(err))
            await axios.get(`${baseUrl}/school-management/${modalInfo.familyId}`, getRequestHeaders())
            .then(res => {
                setLoadingFamilyInfo(false)
                setFamilyProfile(res.data)
                setFamilyInfo(res.data)
                setHookUpFamily(false)
            })
            .catch(err => console.log(err))
        }
    }

    return (
        <div className='family-info-gutter'>
            {
                modalInfo.whichList !== 'inquiry' && 
                    <div className='family-info-gutter__top-tabs__wrapper'>
                        {gutterTabs.map((tab, index) => 
                        <div key={index} className='family-info-gutter__tab' 
                            style={tabState === tab.type ? 
                                {color: '#6366F1', fontWeight: 600, borderBottom: '2px solid #6366F1'} : 
                                {color: '#94A3B8', borderBottom: 'none'}} 
                                onClick={() => setTabState(tab.type)}>
                                {tab.label}
                                {(numberOfInvitations > 0 && tab.label === 'Scheduling') && <p className="family-info-gutter__tab-number">{numberOfInvitations}</p>}
                        </div>)}
                    </div>
            }
            {tabState === 'contact-info' && <ContactInfoTab 
                        modalInfo={modalInfo} 
                        setModalInfo={setModalInfo} 
                        setCopyConfirmationPopup={setCopyConfirmationPopup} 
                        familyInfo={familyInfo} 
                        loadingFamilyInfo={loadingFamilyInfo} 
                        hookUpFamily={hookUpFamily} 
                        scheduledEvents={scheduledEvents} 
                        getFamilyInfo={getFamilyInfo}
                    />
            }
            {tabState === 'scheduling' && <SchedulingTab 
                modalInfo={modalInfo} familyInfo={familyInfo} 
                setSchedulingHelperTeacherId={setSchedulingHelperTeacherId}
                teacherDistanceSuggestions={teacherDistanceSuggestions}
                setTeacherDistanceSuggestions={setTeacherDistanceSuggestions}
                onOpenDistanceScheduler={onOpenDistanceScheduler}
                onOpenBookingDemo={onOpenBookingDemo}
                onOpenTeacherMap={onOpenTeacherMap} />}
        </div>
    )
}
export default FamilyInfoGutter
